import { useEffect } from "react";
import { notifyPageView } from "../../analytics/useAnalyticsEventTracker";
import {
	DATA_TYPES,
	EMPTY_MESSAGES,
	EMPTY_MESSAGE_IMAGES,
} from "../../constants";
import { setMetaTags } from "../../helpers/pageMeta";
import { stateType } from "../../state";
import { EmptyMessage } from "../Common/EmptyMessage";
import { LoadingDialog } from "../Common/LoadingDialog";

import { useStyles } from "../DataIngestion/DataIngestion";
import { DropBatchDataBox } from "./DropBatchDataBox";
import { HistogramBox } from "./HistogramBox";
import { PredictedChartBox } from "./PredictedChartBox";
import { PredictedTable } from "./PredictedTable";

export function BacthPrediction({ state }: stateType) {
	let classes = useStyles();
	useEffect(() => {
		setMetaTags();
		window.scrollTo(0, 0);
		notifyPageView("Batch Prediction Page", window.location.pathname);
	}, []);

	if (state.saveState.savedModels.length === 0) {
		return (
			<EmptyMessage
				image={EMPTY_MESSAGE_IMAGES.pleaseTrain}
				message1={EMPTY_MESSAGES.train1}
				message2={EMPTY_MESSAGES.train2}
			></EmptyMessage>
		);
	}

	let col = state.saveState.dataset.getColumn(
		state.saveState.modelTraining.valueToPredict
	);
	if (col === undefined) {
		return <div></div>;
	}
	let isCat = col.columnType === DATA_TYPES.categorical;

	return (
		<div className={classes.root}>
			<div className={classes.grid}>
				<div className={classes.title}>Batch Prediction</div>
			</div>
			<div className={classes.grid}>
				<div className={classes.subTitle}>
					{`Use your trained ML Models to predict '${state.saveState.modelTraining.valueToPredict}' on an entire dataset.`}
				</div>
			</div>

			<div className={classes.grid}>
				<DropBatchDataBox state={state}></DropBatchDataBox>
			</div>
			<div className={classes.divider2}></div>

			{state.saveState.batchPrediction.batchData === undefined ? (
				<div></div>
			) : (
				<div className={classes.root}>
					<div className={classes.grid}>
						<div className={classes.title}>Model Predictions</div>
					</div>
					<div className={classes.grid}>
						<PredictedTable state={state}></PredictedTable>
					</div>

					<div className={classes.divider2}></div>
					<div className={classes.divider2}></div>

					<div className={classes.grid}>
						<div className={classes.title}>Prediction Analysis</div>
					</div>

					{isCat ? (
						<div className={classes.grid}>
							<PredictedChartBox
								state={state}
							></PredictedChartBox>
						</div>
					) : (
						<div></div>
					)}
					<div className={classes.divider2}></div>
					<div className={classes.grid}>
						<HistogramBox state={state}></HistogramBox>
					</div>
				</div>
			)}
			<div className={classes.grid}>
				<LoadingDialog state={state}></LoadingDialog>
			</div>
		</div>
	);
}
